import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'questionario';

const getQuestionariRichiesti = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_questionari_richiesti" , data: params}, callback);
const getRisposte = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_risposte" , data: params}, callback);
const setQuestionarioValidato = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "set_questionario_validato" , data: params}, callback);
const postaNotaDoc = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "post_nota_doc" , data: params}, callback);
const saveQuestionarioFiles = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "save_files" , data: params}, callback);
const deleteQuestionarioFile = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "delete_file" , data: params}, callback);
const postRisposte = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "post_risposte" , data: params}, callback);
const postGestioneRisposte = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "gestione_risposte" , data: params}, callback);
const chiudiQuestionario = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "chiudi_questionario" , data: params}, callback);
const addRichiesta = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "add_richiesta" , data: params}, callback);
const deleteRichiesta = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "delete_richiesta" , data: params}, callback);
const getTestoMail = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "recupera_testo_mail" , data: params}, callback);


const apiEndpoint = {
  getQuestionariRichiesti,
  getRisposte,
  setQuestionarioValidato,
  postaNotaDoc,
  saveQuestionarioFiles,
  deleteQuestionarioFile,
  postRisposte,
  postGestioneRisposte,
  chiudiQuestionario,
  addRichiesta,
  deleteRichiesta,
  getTestoMail
}

export default apiEndpoint;